import { Loader, Size } from '@transferwise/components';
import { getRateInAllFormats } from '@transferwise/formatting';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import styles from '../../../resources/static/less/comparison-components.module.less';

import MidMarketDescription from './MidMarketDescription';

const createClassNames = (classNames) =>
  classNames.map((className) => `${styles[className]}`).join(' ');

const MidMarketRate = ({ source, target, midMarketRate, loading, lang }) => {
  const { locale } = useIntl();

  return (
    <div
      className={createClassNames([
        'size-1-of-1',
        'd-flex',
        'flex-column',
        'flex-center',
        'flex-left-md',
        'm-b-5',
        'm-b-0-md',
      ])}
      data-testid="mid-market-rate"
    >
      <span className={createClassNames(['d-flex', 'align-items-center'])}>
        <span className={createClassNames(['dot-success', 'animate-blink'])} />
        <strong id="route-rate" className={createClassNames(['h3', 'strong', 'text-md-left'])}>
          {loading ? (
            <Loader size={Size.EXTRA_SMALL} classNames={styles} data-testid="loader" />
          ) : (
            getRateInAllFormats(midMarketRate.rate, source, target, {}, locale).formats.equation
              .output
          )}
        </strong>
      </span>
      <MidMarketDescription rateTime={midMarketRate.time} />
    </div>
  );
};

MidMarketRate.propTypes = {
  source: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  midMarketRate: PropTypes.shape({
    rate: PropTypes.string,
    time: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default MidMarketRate;
